import { AddRounded as AddRoundedIcon } from '@mui/icons-material';
import { Box, Button, Typography } from '@mui/material';
import { FC, Fragment, JSX } from 'react';
import { useNavigate } from 'react-router-dom';
//components
import StaffTable from './StaffTable';
// constant, styles, reducer, graphql
import { ADD_NEW_TEXT, ADD_STAFF_ROUTE, STAFF_TEXT } from 'constants/index';
import { flexCenterBetween } from 'styles/commonComponentStyle';

const Staff: FC = (): JSX.Element => {
  const navigate = useNavigate();

  return (
    <Fragment>
      <Box sx={flexCenterBetween}>
        <Typography variant="h5">{STAFF_TEXT}</Typography>
        <Button variant="contained" color="primary" onClick={() => navigate(ADD_STAFF_ROUTE)}>
          <AddRoundedIcon />
          {ADD_NEW_TEXT}
        </Button>
      </Box>
      <StaffTable />
    </Fragment>
  );
};

export default Staff;
